


import { Component, Vue, Prop, Ref, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Step } from './ProcessBar.models';
import { RouteNames } from '@/utils/router/router.models';

const appModule = namespace('app');

@Component({})
export default class ProcessBar extends Vue {
  @Ref('navigation') navigationEl!: HTMLElement;
  @Ref('wrapper') wrapperEl!: HTMLElement;

  @Prop() private steps!: Step[];

  @appModule.State private fontsLoaded!: boolean;
  @appModule.State private deviceMQ!: string;

  private showScrollLeft = false;
  private showScrollRight = false;

  private RouteNames: typeof RouteNames = RouteNames;

  private scrollLeft() {
    this.scroll(0);
  }

  private scrollRight() {
    this.scroll(this.navigationEl.scrollWidth);
  }

  private scroll(position: number) {
    this.navigationEl.scrollTo({
      top: 0,
      left: position,
      behavior: 'smooth'
    });
  }

  private mounted() {
    this.updateIndicatorPosition();
  }

  @Watch('$route')
  private async routeChanged() {
    await this.$nextTick();
    this.updateIndicatorPosition();
  }

  @Watch('deviceMQ')
  private breakpointChanged() {
    this.updateIndicatorPosition();
  }

  @Watch('fontsLoaded')
  private async fontsLoadedStatusChanged(to: boolean) {
    if (to) this.updateIndicatorPosition();
  }

  private updateIndicatorPosition(el: HTMLElement | null = this.$el.querySelector('.-active')) {
    if (el) {
      this.wrapperEl.style.setProperty('--width', el.clientWidth.toString() + 'px');
      this.wrapperEl.style.setProperty('--left', el.offsetLeft.toString() + 'px');
      this.wrapperEl.style.setProperty('--opacity', '1');
    }
  }
}
